import styled from 'styled-components';
import { Modal } from 'antd';

export const Container = styled(Modal)``;

export const Text = styled.pre`
  font: 18px 'Roboto', sans-serif;
  white-space: pre-wrap;
`;
